/**
 * Utility for preventing layout shifts when toggling navigation menus
 */

// Store a single cached scrollbar width value
let scrollbarWidth;

/**
 * Simple wrapper for handling body overflow locking and padding adjustment
 * to prevent layout shifts when navigation menus are opened/closed
 *
 * @param {boolean} lock - Whether to lock scrolling (true) or unlock it (false)
 */
export function preventLayoutShift(lock) {
  // Skip if we're not in a browser environment
  if (typeof document === "undefined" || !document.body) {
    return;
  }

  if (lock) {
    // Calculate scrollbar width only once
    if (scrollbarWidth === undefined) {
      // Create temporary elements to measure scrollbar width
      const outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.overflow = "scroll";
      document.body.appendChild(outer);

      const inner = document.createElement("div");
      outer.appendChild(inner);

      // Get scrollbar width
      scrollbarWidth = outer.offsetWidth - inner.offsetWidth || 0;

      // Clean up
      document.body.removeChild(outer);
    }

    // Lock scrolling and add padding to prevent layout shift
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  } else {
    // Unlock scrolling and remove padding
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }
}
